module.exports = __webpack_public_path__ + "img/sellerGraph.9acd0ff2.svg";